import './checkout'

$.fn.CartPanel = function() {
  let self = this
  self.fragmentsRequest = undefined
  self.requestResponse = undefined

  self.open = function(e) {
    if (e != undefined) e.preventDefault()
    self.addClass('cart-panel--active')
  }

  self.close = function(e) {
    if (e != undefined) e.preventDefault()
    self.removeClass('cart-panel--active')
  }

  self.fragmentsRefreshed = function(response) {
    /* Fragments behavior */
    self.fragmentsRequest = undefined
    if (response && response.fragments) {
      /* Replace fragments */
      $.each(response.fragments, function(key, value) {
        $(key).replaceWith(value)
      })

      /* Added to cart */
      if ('added_to_cart_message' in response.fragments) {
        let addedNotice = $('<div class="woocommerce-message added-to-cart" role="alert"></div>');
        addedNotice.hide().html(response.fragments.added_to_cart_message)
        $('.woocommerce-notices-wrapper').append(addedNotice.fadeIn(200));
      }

      /* Session storage */
      if ('sessionStorage' in window && window.sessionStorage !== null) {
        sessionStorage.setItem(window.wc_cart_fragments_params.fragment_name, JSON.stringify(response.fragments))
        sessionStorage.setItem(window.wc_cart_fragments_params.cart_hash_key, response.cart_hash)
        sessionStorage.setItem('wc_cart_created', (new Date()).getTime())
        localStorage.setItem(window.wc_cart_fragments_params.fragment_name, JSON.stringify(response.fragments))
        localStorage.setItem(window.wc_cart_fragments_params.cart_hash_key, response.cart_hash)
        localStorage.setItem('wc_cart_created', (new Date()).getTime())
      }

      /* Fragments refreshed */
      $(document.body).trigger('wc_fragments_refreshed')

      /* Display success message */
      $('.woocommerce-message').remove()
      if (self.requestResponse != undefined) {
        if ($('.row-anchor#produits').length) {
          $('.filters-dropdown').after(self.requestResponse.find('.woocommerce-message').css('display', 'flex').hide().fadeIn())
        } else {
          $('.woocommerce-notices-wrapper').append(self.requestResponse.find('.woocommerce-message').css('display', 'flex').hide().fadeIn())
        }
        $(window).ScrollEvents().scrolled()
      }

      /* Checkout */
      if ($('body').hasClass('woocommerce-checkout')) {
        $(document.body).trigger('update_checkout')
      }

      /* Reset add to cart form */
      $('.summary.entry-summary form.cart input[name="quantity"]').val(1).change()
      self.unblock_ui()
      self.requestResponse = undefined
    }
  }

  self.refreshFragments = function(x) {
    self.requestResponse = $('<html>').html(x)
    if (self.requestResponse.find('.add-to-cart-new-fragments').length) {
      let fragments = JSON.parse(self.requestResponse.find('.add-to-cart-new-fragments').text())
      self.fragmentsRefreshed(fragments)
    } else {
      self.fragmentsRequest = $.ajax({
        url: window.wc_cart_fragments_params.wc_ajax_url.replace('%%endpoint%%', 'get_refreshed_fragments'),
        type: 'POST',
        success: function(response) {
          self.fragmentsRefreshed(response)
        },
      })
    }
  }

  self.update = function(e) {
    if (e != undefined) {
      e.preventDefault()
    }
    if (self.fragmentsRequest != undefined) {
      self.fragmentsRequest.abort()
      self.fragmentsRequest = undefined
    }

    self.block_ui()

    let quantities = {}
    self.find('.mini_cart_item').each(function() {
      let quantity = parseInt($(this).find('input[name="quantity"]').val(), 10),
      item_key = $(this).find('.remove_from_cart_button').data('cart_item_key')
      if (isNaN(quantity)) {
        quantity = 0
      }
      if ($(this).hasClass('to-remove')) {
        quantity = 0
      } else if (quantity < 1) {
        $(this).addClass('to-remove')
        quantity = 0
      }
      quantities[item_key] = quantity
    })

    $('.to-remove').slideUp(200, function() {
      $(this).hide().remove()
    })

    $.post(woocommerce_params.ajax_url, {
      action: 'update_cart_quantities',
      quantities: quantities,
      is_checkout: $('body').hasClass('woocommerce-checkout') ? 'yes' : 'no',
    }, function(response) {
      self.unblock_ui()
      self.fragmentsRefreshed(response)
    }, 'json')
  }

  self.initialize = function() {
    self.find('input.qty').each(function() {
      const quantityField = $(this).Quantity()
      quantityField.off('change', self.quantity_changed).on('change', self.update)
    })

    self.find('.remove_from_cart_button').on('click', function(e) {
      e.preventDefault()
      $(this).closest('.mini_cart_item').slideUp(200)
      self.block_ui()
    })

    $('.added_to_cart').click(function(e) {
      $('.cart-panel').addClass('cart-panel--active')
      return false;
    })
  }

  self.removed_from_cart = function() {
    if ($('body').hasClass('woocommerce-checkout')) {
      $(document.body).trigger('update_checkout')
    }
  }

  self.block_ui = function() {
    if ($('body').hasClass('woocommerce-checkout')) {
      $('.woocommerce-checkout-payment, .woocommerce-checkout-review-order-table').block({
        message: null,
        overlayCSS: {
          'background-color': $('body').css('background-color'),
        },
      })
    } else {
      $('.cart-panel__cart-content, .cart-panel__suggestions').block({
        message: null,
        overlayCSS: {
          'background-color': $('.cart-panel__wrapper').css('background-color'),
        },
      })
    }
  }

  self.unblock_ui = function() {
    $('.woocommerce-checkout-payment, .woocommerce-checkout-review-order-table').unblock()
    $('.cart-panel__cart-content, .cart-panel__suggestions').unblock()
    $('form.cart').unblock()
  }

  return function() {
    /* Open or close */
    $(document).on('click', '.js-cart-button > button, button.js-cart-button, a.js-cart-button', self.open)
    self.find('.cart-panel__close-btn').on('click', self.close)
    $(document).on('click', function(e) {
      if (!$(e.target).hasClass('js-cart-button') && $(e.target).parents('.cart-panel').length === 0 && $(e.target).parents('.js-cart-button').length === 0) {
        self.close()
      }
    })

    /* Initialize once */
    $(document.body).off('wc_fragments_loaded', self.initialize).on('wc_fragments_loaded', self.initialize)
    $(document.body).off('wc_fragments_refreshed', self.initialize).on('wc_fragments_refreshed', self.initialize)
    $(document.body).off('removed_from_cart', self.initialize).on('removed_from_cart', self.initialize)
    $(document.body).off('updated_checkout', self.initialize).on('updated_checkout', self.initialize)
    $(document.body).off('removed_from_cart', self.unblock_ui).on('removed_from_cart', self.unblock_ui)
    $(document.body).off('updated_checkout', self.unblock_ui).on('updated_checkout', self.unblock_ui)
    $(document.body).off('added_to_cart', self.initialize).on('added_to_cart', self.initialize)
    $(document.body).off('removed_from_cart', self.removed_from_cart).on('removed_from_cart', self.removed_from_cart)
    setTimeout(self.initialize, 400) // after optimocha
    return self
  }()
}

export default {
  init() {
    if ($.mlmi.cart == undefined) {
      $('.cart-panel').each(function() {
        $.mlmi.cart = $(this).CartPanel()
      })
      $('#order_review').each(function() {
        $.mlmi.cart = $(this).CartPanel()
      })
      $('form.checkout').each(function() {
        $(this).CheckoutForm()
      })
    }
  },

  open() {
    if ($.mlmi.cart != undefined) {
      $.mlmi.cart.open()
    }
  },

  close() {
    if ($.mlmi.cart != undefined) {
      $.mlmi.cart.close()
    }
  },

  refresh(x) {
    if ($.mlmi.cart != undefined) {
      $.mlmi.cart.refreshFragments(x)
    }
  },
}
